import axios from 'axios';
import { Message } from 'element-ui';
const http = axios.create({});

// 请求拦截
http.interceptors.request.use(
  config => {
    config.headers.operationCode = `${sessionStorage.getItem('_token_operationCode') || ''}`
    // config.headers.authorization = 'bearer d1685872-6724-4285-91c0-e029181f2c4e'
    return config
  },
  error => {
    return Promise.reject(error);
  },
);
// 响应拦截
http.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    let message =
      (error &&
        error.response &&
        error.response.data &&
        error.response.data.message) ||
      '服务异常';
      Message({
        dangerouslyUseHTMLString: true,
        message,
        type: 'error',
      });
    return Promise.reject(error)
  },
);

export { http };
